export const DEFAULTS = {
  config: {
    preview: {
      enable: true,
    },
  },
};
export const THEME = colors => ({
  link: {
    color: colors.actionColor,
    textDecoration: 'none',
  },
});
